import { render, staticRenderFns } from "./CategoriePEFC.vue?vue&type=template&id=19728da1"
import script from "./CategoriePEFC.vue?vue&type=script&lang=js"
export * from "./CategoriePEFC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports